export const SEARCH_TERMS = ["title", "meta_title"];
export const inputFields = {
  name: {
    type: "string",
    required: true,
    title: "Title",
    slug: true,
    inputType: "text",
  },
  content: {
    type: "html",
    required: false,
    title: "Content",
  },
  featured_image: {
    type: "file",
    required: false,
    title: "Featured Image",
  },
  gallery: {
    type: "gallery",
    required: false,
    title: "Gallery",
  },
  meta_title: {
    type: "string",
    required: false,
    title: "Meta Title",
  },
  meta_description: {
    type: "text",
    required: false,
    title: "Meta Description",
  },
  slug: {
    type: "slug",
    required: false,
    targetField: "title",
    title: "Slug",
  },
};
export const initialValues = {
  title: "",
  content: "",
  meta_title: "",
  meta_description: "",
  slug: "",
};

export const view_all_table = [
  { name: "First Name", value: "first_name" },
  { name: "Last Name", value: "last_name" },
  { name: "Phone", value: "phone" },
  { name: "Email", value: "email" },
];
